import React, {Component} from 'react';
import {QuestionRankingFieldOption} from './QuestionRankingFieldOption';

export class QuestionRankingField extends Component {
    render() {
        const {questionOptions, disabled} = this.props;
        const questionOptionsLength = questionOptions.length;

        return questionOptionsLength > 0 ?
            questionOptions.map((item, index) => <QuestionRankingFieldOption item={item}
                index={index}
                movePosition={(oldIndex, newIndex) => this.props.movePosition(questionOptions, oldIndex, newIndex)}
                moveUp={(index, questionOptions) => this.props.moveUp(index, questionOptions)}
                moveDown={(index, questionOptions) => this.props.moveDown(index, questionOptions)}
                disabled={disabled}
                questionOptions={questionOptions}
                questionOptionsLength={questionOptionsLength} />) : <div />;
    }
}
